import React from 'react';
import {
  BrowserRouter, Routes, Route, Navigate,
} from 'react-router-dom';
import Home from './public/pages/Home';
import ReportOccurence from './public/pages/ReportOccurence';
import SrmForms from './private/pages/SrmForms';
import AllArticles from './public/pages/AllArticles';
import Article from './public/pages/Article';
import Login from './public/components/login/Login';
import Unsubscribe from './public/components/newsletter/Unsubscribe';
import Public from './Public';
import Private from './Private';
import Dashboard from './private/pages/Dashboard';
import Occurrences from './private/pages/Occurrences';
import SafetyLogs from './private/pages/safety-assurance/SafetyLogs';
import Users from './private/pages/users/Users';
import UserForm from './private/pages/users/UserForm';
import ArticleForm from './private/pages/publicContent/articles/ArticleForm';
import PublicatonForm from './private/pages/publicContent/publications/PublicationForm';
import NewsLetterForm from './private/pages/publicContent/newsletters/NewsLetterForm';
import PublishedArticles from './private/pages/publicContent/articles/PublishedArticles';
import PublishedPublications from './private/pages/publicContent/publications/PublishedPublications';
import EditArticle from './private/pages/publicContent/articles/EditArticle';
import EditPublication from './private/pages/publicContent/publications/EditPublication';
import Modal from './private/components/Modal';
import PublishedNewsLetter from './private/pages/publicContent/newsletters/PublishedNewsLetter';
import EditNewsLetter from './private/pages/publicContent/newsletters/EditNewsLetter';
import SafetyLogsForm from './private/pages/safety-assurance/SafetyLogsForm';
import Lessons from './private/pages/Lessons';
import QuizAssessment from './public/components/online-obj-assessment/quiz-assessment';
import CoursePage from './public/components/online-course-page/course-page';
import ResetPassword from './public/pages/ResetPassword';
import CourseManagementDashboard from './private/pages/publicContent/online-courses/course-management-dashboard';
import RedirectToOCMS from './private/pages/RedirectToOCMS';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/public" replace />} />
        <Route path="public" element={<Public />}>
          <Route index element={<Home />} />
          <Route exact path="articles" element={<AllArticles />} />
          <Route exact path="article/:id" element={<Article />} />
          <Route exact path="report" element={<ReportOccurence />} />
          <Route exact path="login" element={<Login />} />
          <Route exact path="unsubscribe" element={<Unsubscribe />} />
          <Route exact path="quiz-assessment" element={<QuizAssessment />} />
          <Route exact path="online-course" element={<CoursePage />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route
            path="*"
            element={(
              <h1 className="font-bold w-full text-5xl text-center p-32">
                404 NOT FOUND
              </h1>
            )}
          />

        </Route>
        <Route path="private" element={<Private />}>
          <Route path="srm" element={<SrmForms />} />
          <Route path="modal" element={<Modal />} />
          <Route path="srm/:id" element={<SrmForms />} />
          <Route index element={<Dashboard />} />
          <Route exact path="users" element={<Users />} />
          <Route exact path="safetylogs-form" element={<SafetyLogsForm />} />
          <Route exact path="safety-logs/all" element={<SafetyLogs />} />
          <Route exact path="occurrences/all" element={<Occurrences />} />
          <Route exact path="user-form/:usr" element={<UserForm />} />
          <Route exact path="articles-form" element={<ArticleForm />} />
          <Route exact path="publications-form" element={<PublicatonForm />} />
          <Route exact path="editArticle/:id" element={<EditArticle />} />
          <Route
            exact
            path="editPublication/:id"
            element={<EditPublication />}
          />
          <Route
            exact
            path="newsletter/get-newsletter/:id"
            element={<EditNewsLetter />}
          />
          <Route exact path="newsletter-form" element={<NewsLetterForm />} />
          <Route
            exact
            path="publications"
            element={<PublishedPublications />}
          />
          <Route exact path="articles" element={<PublishedArticles />} />
          <Route
            exact
            path="newsletter/get-all-newsletters"
            element={<PublishedNewsLetter />}
          />
          <Route exact path="lessons" element={<Lessons />} />
          <Route exact path="ocms-redirect" element={<RedirectToOCMS />} />

          <Route
            path="*"
            element={(
              <h1 className="font-bold w-full text-5xl text-center p-32">
                404 NOT FOUND
              </h1>
            )}
          />
        </Route>
        <Route exact path="online-courses/dashboard" element={<CourseManagementDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
